import { useTexture } from "@react-three/drei";
import { useEffect } from "react";
import * as THREE from "three";

export interface SpaceSkyProps {
  /** Path to the HDRI texture */
  textureSrc: string;
}

export function SpaceSky({ textureSrc }: SpaceSkyProps) {
  const texture = useTexture(textureSrc) as THREE.Texture;

  useEffect(() => {
    texture.mapping = THREE.EquirectangularReflectionMapping;
  }, [texture]);

  return (
    <mesh>
      <sphereGeometry args={[50, 64, 64]} />
      <meshBasicMaterial
        map={texture}
        side={THREE.BackSide}
        fog={false}
        color={0x666666}
      />
    </mesh>
  );
}
